var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpBigArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75007 11.2499L6.75007 2.87236L10.4101 6.53236C10.7026 6.82486 11.1826 6.82486 11.4751 6.53236C11.7676 6.23986 11.7676 5.76736 11.4751 5.47486L6.53257 0.532363C6.24007 0.239863 5.76757 0.239863 5.47507 0.532363L0.532566 5.47486C0.240067 5.76736 0.240067 6.23986 0.532566 6.53236C0.825067 6.82486 1.29757 6.82486 1.59007 6.53236L5.25007 2.87236L5.25007 11.2499C5.25007 11.6624 5.58757 11.9999 6.00007 11.9999C6.41257 11.9999 6.75007 11.6624 6.75007 11.2499Z",
    fill: "#1EBC61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpBigArrow);
export default __webpack_public_path__ + "static/media/upBigArrow.5ec2b66ca6f49988fce76ed1651539d1.svg";
export { ForwardRef as ReactComponent };